import { notification } from 'components/ds';

interface ApiErrorDetail {
  Message?: string;
  Response?: string[];
}

interface ApiErrorItem {
  code: string;
  description: string;
  type: string;
  numericType: number;
}

interface ApiErrorResponse {
  status: number;
  errors: ApiErrorItem[];
}

export const handleApiError = (error: any, title = 'Erro'): void => {
  const errorResponse = error?.response?.data as ApiErrorResponse;

  if (errorResponse?.errors?.length > 0) {
    // Itera sobre todos os erros
    errorResponse.errors.forEach(errorItem => {
      try {
        // Extrai o JSON da string de descrição após o ": "
        const jsonStr = errorItem.description.split(': ')[1];
        const parsedError = JSON.parse(jsonStr) as ApiErrorDetail;
        let description = 'Ocorreu um erro inesperado. Tente novamente mais tarde.';

        // Verifica se há mensagens específicas no Response array
        if (parsedError.Response?.length) {
          for (const response of parsedError.Response) {
              description = response
              break;            
          }
        }

        notification.error({
          message: title,
          description
        });
      } catch {
        // Se não conseguir fazer o parse, usa a description original
        notification.error({
          message: title,
          description: errorItem.description
        });
      }
    });
  } else {
    // Fallback para erro genérico quando não há array de erros
    notification.error({
      message: title,
      description: 'Ocorreu um erro inesperado. Tente novamente mais tarde.'
    });
  }
}; 